import results from '../results';


export default ({ first, last }) => {
    const id = `${last}${first}`;
    return results[id];
}
